import _ from 'lodash';

const ACTIONS = {
    GET_PLAYER_SUCCESS: 'GET_PLAYER_SUCCESS',
    GET_PLAYER_ERROR: 'GET_PLAYER_ERROR',
    GET_OPPONENT_PLAYER_SUCCESS: 'GET_OPPONENT_PLAYER_SUCCESS',
    GET_OPPONENT_PLAYER_ERROR: 'GET_OPPONENT_PLAYER_ERROR',
};

const initialState = {
    player: [],
    opp_player: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.GET_PLAYER_SUCCESS:
            if (_.isArray(action.data)) {
                return {
                    ...state,
                    player: action.data,
                };
            }
            if (action.data.message) {
                return {
                    ...state,
                    player: []
                }
            }
            return {
                ...state,
            };
        case ACTIONS.GET_PLAYER_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        case ACTIONS.GET_OPPONENT_PLAYER_SUCCESS:
            if (_.isArray(action.data)) {
                return {
                    ...state,
                    opp_player: action.data,
                };
            }
            if (action.data.message) {
                return {
                    ...state,
                    opp_player: []
                }
            }
            return {
                ...state,
            };
        case ACTIONS.GET_OPPONENT_PLAYER_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};
